import script from "./ProgressBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgressBar.vue?vue&type=script&setup=true&lang=ts"

import "./ProgressBar.vue?vue&type=style&index=0&id=74c84a60&lang=scss"

const __exports__ = script;

export default __exports__